export default "__VITE_ASSET__CfSyF7Dw__"